import * as yup from 'yup';
import { CompanyNew as TEXT } from 'locales/en';

export const FIELD_NAMES = {
  display_name: 'display_name',
  legal_business_name: 'legal_business_name',
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  phone_number: 'phone_number',
  country: 'country',
  legal_entity: 'legal_entity',
  mcc_code: 'mcc_code',
  google_pay_merchant_id: 'google_pay_merchant_id',
  checkout_logo: 'checkout_logo',
  shortcode: 'shortcode',
  account_holder_code: 'account_holder_code',
  stripe_account_id: 'stripe_account_id',
  client_id: 'client_id',
  fee_structure_id: 'fee_structure_id',
  integration_id: 'integration_id',
  caboodle_fleet: 'caboodle_fleet',
};

export const defaultValues = {
  [FIELD_NAMES.display_name]: '',
  [FIELD_NAMES.legal_business_name]: '',
  [FIELD_NAMES.first_name]: '',
  [FIELD_NAMES.last_name]: '',
  [FIELD_NAMES.email]: '',
  [FIELD_NAMES.phone_number]: '',
  [FIELD_NAMES.country]: {},
  [FIELD_NAMES.legal_entity]: {},
  [FIELD_NAMES.mcc_code]: {},
  [FIELD_NAMES.google_pay_merchant_id]: '',
  [FIELD_NAMES.checkout_logo]: null,
  [FIELD_NAMES.shortcode]: '',
  [FIELD_NAMES.account_holder_code]: '',
  [FIELD_NAMES.stripe_account_id]: '',
  [FIELD_NAMES.client_id]: {},
  [FIELD_NAMES.fee_structure_id]: {},
  [FIELD_NAMES.integration_id]: {},
  [FIELD_NAMES.caboodle_fleet]: false,
};

const CHECKOUT_LOGO_SIZE = 1048576; //1MB
const CHECKOUT_LOGO_TYPES = ['image/jpeg', 'image/png'];

const schema = yup.object().shape({
  [FIELD_NAMES.display_name]: yup.string().required(TEXT.errors.display_name),
  [FIELD_NAMES.legal_business_name]: yup
    .string()
    .required(TEXT.errors.legal_business_name),
  [FIELD_NAMES.first_name]: yup.string().required(TEXT.errors.first_name),
  [FIELD_NAMES.last_name]: yup.string().required(TEXT.errors.last_name),
  [FIELD_NAMES.email]: yup.string().email().required(TEXT.errors.email),
  [FIELD_NAMES.phone_number]: yup.string().required(TEXT.errors.phone_number),
  [FIELD_NAMES.country]: yup.object().shape({
    name: yup.string().nullable().required(TEXT.errors.country),
    dial_code: yup.string(),
    code: yup.string(),
  }),
  [FIELD_NAMES.legal_entity]: yup.object().shape({
    label: yup.string().nullable().required(TEXT.errors.legal_entity),
    value: yup.string().nullable(),
  }),
  [FIELD_NAMES.mcc_code]: yup.object().shape({
    label: yup.string().nullable().required(TEXT.errors.mcc_code),
    value: yup.string().nullable(),
  }),
  [FIELD_NAMES.google_pay_merchant_id]: yup.string().nullable(),
  [FIELD_NAMES.checkout_logo]: yup
    .mixed()
    .nullable()
    .test('size', TEXT.errors.checkout_logo.max, (value) => {
      if (!value?.lastModified) {
        return true;
      } else {
        return value && value.size <= CHECKOUT_LOGO_SIZE;
      }
    })
    .test('type', TEXT.errors.checkout_logo.type, (value) => {
      if (!value?.lastModified) {
        return true;
      } else {
        return value && CHECKOUT_LOGO_TYPES.indexOf(value.type) > -1;
      }
    }),
  [FIELD_NAMES.shortcode]: yup.string().nullable(),
  [FIELD_NAMES.account_holder_code]: yup.string().nullable(),
  [FIELD_NAMES.stripe_account_id]: yup.string().nullable(),
  [FIELD_NAMES.client_id]: yup.object().shape({
    label: yup.string().nullable().required(TEXT.errors.client_id),
    value: yup.string().nullable(),
  }),
  [FIELD_NAMES.fee_structure_id]: yup.object().shape({
    label: yup.string().nullable(),
    value: yup.string().nullable(),
  }),
  [FIELD_NAMES.integration_id]: yup.object().shape({
    label: yup.string().nullable(),
    value: yup.string().nullable(),
  }),
  [FIELD_NAMES.caboodle_fleet]: yup.boolean(),
});

export default schema;
